import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

interface ListItemProps {
  focused?: boolean
}

export const ListItem = styled.li<ListItemProps>`
  display: flex;
  padding: ${Spacing.S8} ${Spacing.S16};
  border-top: 1px solid ${Color.Grey150};
  background-color: ${({ focused }) => (focused ? transparentize(0.75, Color.Grey300) : Color.White)};
  cursor: pointer;

  &:first-of-type {
    border-top: none;
  }
  &:hover {
    background-color: ${transparentize(0.75, Color.Grey300)};
  }
`

export const IconWrapper = styled.figure`
  margin-top: ${Spacing.S4};
  margin-right: ${Spacing.S12};
`

export const ContentWrapper = styled.div``
